import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import { MultipleSelect } from 'react-select-material-ui';
import { theme } from '../../themes/theme';
import * as S from './MultiSelect.css';
const MultiSelect = (props) => {
    const required = props.isRequired ? '*' : '';
    const [active, setActive] = useState(false);
    const getLabelColor = () => {
        if (props.disabled) {
            return theme.palette.grey[400];
        }
        else if (active) {
            return theme.palette.primary.main;
        }
        return theme.palette.text.secondary;
    };
    const styles = {
        control: () => ({
            alignItems: 'flex-end',
            minHeight: '30px',
            borderColor: getLabelColor(),
        }),
        container: () => ({
            marginTop: '10px',
        }),
        menuPortal: (base) => (Object.assign(Object.assign({}, base), { zIndex: 9999 })),
        clearIndicator: () => !props.isClearable && { display: 'none' },
        multiValueRemove: (provided, state) => {
            return state.data.isFixed ? Object.assign(Object.assign({}, provided), { display: 'none' }) : provided;
        },
    };
    return (_jsxs("div", { children: [_jsx(Controller, { render: ({ value, name, onChange, onBlur }) => {
                    var _a, _b, _c;
                    return (_jsx(MultipleSelect, { InputLabelProps: {
                            style: {
                                color: getLabelColor(),
                            },
                        }, style: {
                            textTransform: 'capitalize',
                            color: props.disabled ? getLabelColor() : '',
                        }, label: props.label ? `${props.label}${required}` : '', name: name, options: (_a = props.options) !== null && _a !== void 0 ? _a : [], values: value, onInput: props.onInputChange, onChange: (value, option) => {
                            onChange(value);
                            if (props.onChange) {
                                props.onChange(value, option);
                            }
                        }, onBlur: (_) => {
                            onBlur();
                            if (props.onBlur) {
                                props.onBlur();
                            }
                        }, onFocus: props.onFocus, onFocusCapture: () => setActive(true), onBlurCapture: (event) => {
                            setActive(false);
                            props.dontCloseMenuOnSelect && event.stopPropagation();
                        }, SelectProps: {
                            isValidNewOption: (inputValue) => inputValue !== '',
                            isClearable: props.isClearable,
                            isSearchable: props.isSearchable,
                            isLoading: props.isLoading,
                            menuPlacement: (_b = props.menuPlacement) !== null && _b !== void 0 ? _b : 'auto',
                            menuShouldBlockScroll: true,
                            maxMenuHeight: (_c = props.maxMenuHeight) !== null && _c !== void 0 ? _c : 220,
                            autoFocus: props.autoFocus,
                            menuPortalTarget: document.body,
                            styles: styles,
                            closeMenuOnSelect: false,
                            msgNoOptionsAvailable: props.noOptionsMessage,
                            onKeyDown: (event) => {
                                //ESC should close select dropdown menu and not the whole modal
                                event.stopPropagation();
                                if (props.onKeyDown) {
                                    props.onKeyDown(event);
                                }
                            },
                        }, disabled: props.disabled, size: "small", margin: "dense", placeholder: props.placeholder, helperText: props.helperText }));
                }, rules: { validate: (value) => !props.isRequired || (value === null || value === void 0 ? void 0 : value.length) > 0 }, control: props.control, name: props.name, defaultValue: [] }), props.error && _jsx(S.Error, { children: "This field is required" })] }));
};
export default MultiSelect;
